// extracted by mini-css-extract-plugin
export default {"box":"styles_box__0NRhD","wrapper":"styles_wrapper__8mGH5"};